export default __webpack_public_path__ + "static/media/Q42019.fd55041e.PDF";